import * as R from 'ramda';

const defaultState = {
  byId: {},
  draftsById: {},
  keyWindows: [],
};

export const fetchQuery = (keyWindow, id) => ({
  type: 'FETCH_QUERY',
  payload: {
    keyWindow,
    id,
  },
});

export const defineQuery = (keyWindow, id, props) => ({
  type: 'DEFINE_QUERY',
  payload: {
    keyWindow,
    id,
    props,
  },
});

export const deleteQuery = (keyWindow, id) => ({
  type: 'DELETE_QUERY',
  payload: {
    keyWindow,
    id,
  },
});

export const saveQuery = (keyWindow, id, data) => ({
  type: 'SAVE_QUERY',
  payload: {
    keyWindow,
    id,
    data,
  },
});

export const editQuery = (id, props) => ({
  type: 'EDIT_QUERY',
  payload: {
    id,
    props,
  },
});

export const renameQuery = (keyWindow, id, query) => ({
  type: 'RENAME_QUERY',
  payload: {
    keyWindow,
    id,
    query,
  },
});


export const undoEditQuery = (id, keys) => ({
  type: 'UNDO_EDIT_QUERY',
  payload: {
    id,
  },
});

export const receiveQuery = (keyWindow, category) => {
  return ({
    type: 'RECEIVE_ENTITIES',
    payload: {
      keyWindow,
      entities: {
        queries: {
          byId: R.indexBy(R.prop('id'), [category]),
          ids: R.pluck('id')([category]),
        },
      },
    },
  });
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'SAVE_QUERY':
    case 'FETCH_QUERY':
    case 'RENAME_QUERY':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: true,
        },
      };
    case 'DEFINE_QUERY':
      return {
        ...state,
        draftsById: {
          ...state.draftsById,
          [action.payload.id]: {
            ...action.payload.props,
            id: action.payload.id,
          },
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          ids: [action.payload.id],
        },
      };
    case 'EDIT_QUERY': {
      return {
        ...state,
        draftsById: {
          ...state.draftsById,
          [action.payload.id]: {
            ...state.draftsById[action.payload.id],
            ...action.payload.props,
          },
        },
      };
    }
    case 'UNDO_EDIT_QUERY': {
      return {
        ...state,
        draftsById: {
          ...R.omit([action.payload.id], state.draftsById),
        },
      };
    }
    case 'RECEIVE_ENTITIES':
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', 'queries', 'byId'], action),
        },
        draftsById: {
          ...R.omit(R.pathOr([], ['payload', 'entities', 'queries', 'ids'], action), state.draftsById),
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          ids: R.path(['payload', 'entities', 'queries', 'ids'], action)
            ? R.path(['payload', 'entities', 'queries', 'ids'], action)
            : R.path([action.payload.keyWindow, 'ids'], state),
        },
      };
    case 'RECEIVE_ERRORS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
        },
      };
    case 'RELEASE_KEY_WINDOW':
      return {
        ...R.omit([action.payload.keyWindow], state),
        keyWindows: state.keyWindows.filter(kw => kw !== action.payload.keyWindow),
      };
    default:
      return state;
  }
}
